export default __webpack_public_path__ + "cfc1277062c7fa2e29eedb79d02c7e4b.svg";